/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Container, Row,
} from 'react-bootstrap';
import './HowItWorks.css';
import ComprehensiveITServices from './images/Comprehensive IT Services.jpeg';
import ExpertConsultancy from './images/Expert Consultancy.jpeg';
import InnovativeSolutions from './images/Innovative Solutions.jpeg';

const HowItWorks = () => {
  const works = [
    {
      title: 'Personal Care Assistance',
      content: 'Empowering individuals with the support they need for daily activities, including bathing, dressing, and grooming. We understand the importance of maintaining independence while ensuring a helping hand is always within reach.',
      imageUrl: ComprehensiveITServices,
    },
    {
      title: 'Companion Care',
      content: 'At Health Xchange, we recognize the value of companionship in promoting mental and emotional well-being. Our Companion Care services focus on social interaction and recreational activities, fostering meaningful connections for a fulfilling life.',
      imageUrl: ExpertConsultancy,
    },
    {
      title: 'Medical Care',
      content: 'Offering skilled nursing, precise medication management, and health monitoring, Health Xchange ensures that individuals receive the highest standard of medical care in the comfort of their homes.',
      imageUrl: InnovativeSolutions,
    },
    {
      title: 'Home Health Aide Services',
      content: 'Going beyond basic care, our Home Health Aide Services extend to light housekeeping, meal preparation, and assistance with daily errands. We strive to create an environment that promotes both health and comfort.',
      imageUrl: InnovativeSolutions,
    },
    {
      title: 'Tele Health Services',
      content: 'Embracing the future of healthcare, Health Xchange integrates Telehealth Services to provide virtual consultations and remote monitoring. This innovative approach enhances accessibility, ensuring continuous and convenient healthcare support.',
      imageUrl: InnovativeSolutions,
    },
    {
      title: 'Therapeutic Services',
      content: 'We understand the importance of holistic care. Health Xchange offers Therapeutic Services, including physical therapy, occupational therapy, and speech therapy, catering to diverse needs and promoting overall well-being.',
      imageUrl: InnovativeSolutions,
    },
  ];
  return (
    <Container id="howitworks" className="my-5">
      <h2 className="text-center mb-4">How it works</h2>
      <Row className="work-card_container">
        {works.map((work, index) => {
          const isOdd = index % 2 === 0;
          const cardClass = isOdd ? 'odd-card' : 'even-card';
          return (
            <div key={index} className="card-container">
              <div className={`card-content ${cardClass}`}>
                {isOdd ? (
                  <>
                    <div className="card-image ">
                      <img src={work.imageUrl} alt="Card" />
                    </div>
                    <div className="card-text">
                      <h2>{work.title}</h2>
                      <p>{work.content}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="card-text">
                      <h2>{work.title}</h2>
                      <p>{work.content}</p>
                    </div>
                    <div className="card-image">
                      <img src={work.imageUrl} alt="Card" />
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
      </Row>
    </Container>
  );
};

export default HowItWorks;
